import { render, staticRenderFns } from "./vue-footer.vue?vue&type=template&id=794c22f4&scoped=true&"
import script from "./vue-footer.vue?vue&type=script&lang=js&"
export * from "./vue-footer.vue?vue&type=script&lang=js&"
import style0 from "./vue-footer.vue?vue&type=style&index=0&id=794c22f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794c22f4",
  null
  
)

export default component.exports